import React from "react";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "./ui/accordion";
import { faqs } from "../mock";

const FAQSection = () => {
    return (
        <section className="py-24 bg-white">
            <div className="max-w-4xl mx-auto px-6">
                {/* Section header */}
                <div className="text-center mb-16">
                    <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
                        Frequently Asked Questions
                    </h2>
                    <p className="text-xl text-slate-600 leading-relaxed">
                        Everything you need to know about Nucleus. Can't find
                        what you're looking for?{" "}
                        <a
                            href="https://docs.google.com/forms/d/e/1FAIpQLSeSw1JKGrFydRwtW0OmaMVGNQqHwvw1CPLDYGPF-qY80jK_cQ/viewform?usp=publish-editor"
                            className="text-blue-600 hover:text-blue-700 font-semibold underline"
                        >
                            Get in touch
                        </a>
                        .
                    </p>
                </div>

                {/* FAQ Accordion */}
                <Accordion type="single" collapsible className="space-y-4">
                    {faqs.map((faq, idx) => (
                        <AccordionItem
                            key={idx}
                            value={`item-${idx}`}
                            className="border-2 border-slate-200 rounded-lg px-6 hover:border-blue-300 transition-colors duration-300"
                        >
                            <AccordionTrigger className="text-left text-lg font-semibold text-slate-900 hover:text-blue-600 py-6">
                                {faq.question}
                            </AccordionTrigger>
                            <AccordionContent className="text-slate-600 leading-relaxed pb-6">
                                {faq.answer}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>

                {/* Bottom CTA */}
                <div className="mt-16 text-center p-8 bg-gradient-to-r from-blue-50 to-teal-50 rounded-2xl border-2 border-blue-200">
                    <h3 className="text-2xl font-bold text-slate-900 mb-3">
                        Still have questions?
                    </h3>
                    <p className="text-slate-600 mb-6">
                        Our team is here to help you understand how Nucleus can
                        transform your engineering operations.
                    </p>
                    <a
                        target="_blank"
                        href="https://docs.google.com/forms/d/e/1FAIpQLSeSw1JKGrFydRwtW0OmaMVGNQqHwvw1CPLDYGPF-qY80jK_cQ/viewform?usp=publish-editor"
                        className="inline-flex items-center justify-center px-8 py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg shadow-lg transition-all duration-300 hover:shadow-xl"
                    >
                        Contact Sales
                    </a>
                </div>
            </div>
        </section>
    );
};

export default FAQSection;
